import { action } from '@reatom/framework'

import { Result } from '@blade/std-lib'
import { pairRegistry } from '@root/entities/pair'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { ApiError, apiRequest } from '@root/shared/api'

import { PairActivity } from '../model'

export const fetchPremiumFeedRequestAction = action(
  async (ctx, { limit }: { limit: number }) => {
    const {
      tradeApiClient,
      environment: {
        assets: { tokenLogosHost, avatarsHost },
      },
    } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.premium.premiumPurchasesFeedList, [
        {
          limit,
        },
      ]),
    )

    return result.pipe(
      Result.mapError(ApiError.fallbackToUnknown),
      Result.map((it) => {
        return it.map((dto) => {
          const pair =
            'pairInfo' in dto && dto.pairInfo
              ? pairRegistry.resolveFromDto(ctx, dto.pairInfo)
              : undefined
          return PairActivity.fromDto(
            dto,
            pair,
            tokenLogosHost,
            avatarsHost,
          ) as PairActivity.PremiumActivity
        })
      }),
    )
  },
  'fetchPremiumFeedRequestAction',
)
